import Api, { ApiBase } from "../utils/api";
import { ICreateAttemptResponse } from "models/dto/ZoomiLxp/Models/LMS/ICreateAttemptResponse";
import { IPackageMetadata } from "models/dto/ZoomiLxp/Models/LMS/IPackageMetadata";
import { AxiosResponse } from "axios";
import { IResponseModel } from "models/dto/ZoomiLxp/Models/Common/IResponseModel";
import { IActivityInfo } from "models/dto/ZoomiLxp/Models/LMS/IActivityInfo";
import { ICreateAttemptRequest } from "models/dto/ZoomiLxp/Models/LMS/ICreateAttemptRequest";
import { IPackageContentUrlModel } from "models/dto/ZoomiLxp/Models/LMS/IPackageContentUrlModel";

export class LmsApi {
	static createAttempt(id: string, sessionId?: number) {
		return ApiBase.post<ICreateAttemptRequest, AxiosResponse<IResponseModel<ICreateAttemptResponse>>>(
			"/LMS/CreateAttempt",
			{
				organizationId: id,
				sessionId,
			}
		);
	}

	static getPackageMetadata(contentId: number, sessionId?: number) {
		return Api.get<IPackageMetadata>(`/LMS/GetPackageMetadata/${contentId}`, { params: { sessionId } });
	}

	static getActivityInfo(view: number, attemptId: number, sessionId?: number) {
		return Api.get<IActivityInfo>(`/LMS/ActivityInfo/${view}/${attemptId}`, { params: { sessionId } });
	}

	static getPackageContentUrl(contentId: number, sessionId: number) {
		return Api.get<IPackageContentUrlModel>(`/LMS/PackageContentUrl/${contentId}`, { params: { sessionId } });
	}

	static setActivityInfo(view: number, attemptId: number) {
		return Api.post<IActivityInfo, AxiosResponse<IResponseModel<IActivityInfo>>>(
			`/LMS/ActivityInfo/${view}/${attemptId}`
		);
	}

	static getPackageContent(contentId: number) {
		return Api.get<string>(`/LMS/PackageContent/${contentId}/`);
	}
}
